<template>
    <div class="column-layout">
        <div class="base-search-container pt10 pb10 mb10" style="background-color: #f6f8f9">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="合同服务商" name="contract"></el-tab-pane>
            <el-tab-pane label="备选服务商" name="merchtRel"></el-tab-pane>
        </el-tabs>

        <!-- 合同中的服务商 -->
        <div class="table-layout" v-if="showContract">
            <el-table ref="tableList" :data="merchantList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <el-radio v-model="servicer.id" :label="rows.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="服务商名称" align="left">
                    <template slot-scope="rows">
                        <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标签" align="left">
                    <template slot-scope="rows">
                        <el-tag size="small" v-if="!rows.row.yjFeeSuffient">佣金欠费</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="rsFlag" label="卖方关联" align="center" width="100">
                    <template slot-scope="rows">
                        <el-tag type="success" v-if="rows.row.rsFlag">卖方关联</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="industryType.name" label="经营模式" align="left" width="200"></el-table-column>
                <el-table-column prop="staffCount" label="公司规模" align="left" width="100"></el-table-column>
                <el-table-column label="注册资金(元)" align="right" width="200">
                    <template slot-scope="rows">
                        <div v-if="rows.row.registCapital != null">
                            <span>{{((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 客户关系中的服务商 -->
        <div class="table-layout" v-if="showMerchtRel">
            <el-table ref="tableList" :data="merchantBizRelList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55" current-row-key="merchantBizRelList">
                    <template slot-scope="rows">
                        <el-radio v-model="servicer.id" :label="rows.row.peerMerchantId">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="peerMerchantName" label="商户名称" align="left" current-row-key="merchantBizRelList"></el-table-column>
                <el-table-column prop="rsFlag" label="卖方关联" align="center" width="100" current-row-key="merchantBizRelList">
                    <template slot-scope="rows">
                        <el-tag type="success" v-if="rows.row.rsFlag">卖方关联</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="bizDesc" label="业务描述" align="left" current-row-key="merchantBizRelList"></el-table-column>
                <el-table-column prop="dateStart" label="开始日期" align="center" current-row-key="merchantBizRelList"></el-table-column>
                <el-table-column prop="dateEnd" label="截止日期" align="center" current-row-key="merchantBizRelList"></el-table-column>
                <el-table-column label="星级标记" align="center" current-row-key="merchantBizRelList">
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.starLevel == 0">待入围</span>
                        <span class="font-black" v-else>{{rows.row.starLevel}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, EventBus } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servicerApi from '../../api/servicer'
    import merchtComnApi from '../../api/merchtComn'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "服务商名称",
                "code": "sndPartyName",
                "basic": true,
                "valueType": "String"
            }
        ]
    };

    export default {
        name: 'swb-def-servicer-for-select',
        desc: '默认服务商-选择(单选)',
        props: {
            //单选初始选择项
            initCheckedItem: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                merchantList: [],
                merchantBizRelList: [],
                servicer: null,
                //
                filterItems: {
                    name: null
                },
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                activeName: 'contract',
                showContract: true,
                showMerchtRel: false,
            }
        },
        created: function () {
            this.queryConfig = searchConfigData || {};
            //
            this.pageSize = this.pageSizes.first();
            this.servicer = this.initCheckedItem;
            this.getMerchantList();
        },
        methods: {
            // 页签切换
            handleClick: function () {
                this.showContract = false;
                this.showMerchtRel = false;
                //
                if(this.activeName === "contract") {
                    this.showContract = true;
                    this.getMerchantList();
                } else if(this.activeName === "merchtRel") {
                    this.showMerchtRel = true;
                    this.getTypeFlagMerchantBizRelList();
                }
            },
            handleCurrentChange: function (val) {
                if(this.showContract) {
                    if(val != null) {
                        this.servicer.id = val.id;
                        this.servicer.name = val.name;
                    }
                } else {
                    if(val != null) {
                        this.servicer.id = val.peerMerchantId;
                        this.servicer.name = val.peerMerchantName;
                    }
                }
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                if(this.showContract) {
                    this.getMerchantList();
                } else {
                    this.getTypeFlagMerchantBizRelList();
                }
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                if(this.showContract) {
                    this.getMerchantList();
                } else {
                    this.getTypeFlagMerchantBizRelList();
                }
            },
            getMerchantList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = this.queryModel.filterItems;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerListByRelevanceContract(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.merchantList = result.data.rows || [];
                        //
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getTypeFlagMerchantBizRelList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let filterItems = this.queryModel.filterItems;
                let sndPartyName = filterItems.sndPartyName;
                if(!Utils.isNoB(sndPartyName)) {
                    filterItems.peerMerchantName = sndPartyName;
                }
                filterItems.peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                merchtComnApi.getMerchantBizRelListUnbacked(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.merchantBizRelList = result.data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                //
                if(this.servicer.id == null) {
                    result.type = "warn";
                    result.message = "请选择默认服务商";
                } else {
                    result.type = "info";
                    result.data = this.servicer;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servicer/DefServicerForSelect.vue